export enum InterruptionDirection {
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}

export enum InterruptionType {
  OnCallEmergency = 'ON_CALL_EMERGENCY',
  TaskStatusPing = 'TASK_STATUS_PING',
}

export enum InterruptionLifecycleStatus {
  New = 'NEW',
  Sent = 'SENT',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
}

export enum InterruptionEmployeeResponseStatus {
  New = 'NEW',
  Done = 'DONE',
  Postponed = 'POSTPONED',
  Accepted = 'ACCEPTED',
  WillFinishToday = 'WILL_FINISH_TODAY',
  WillFinishNextCheckin = 'WILL_FINISH_NEXT_CHECKIN',
  Dismissed = 'DISMISSED',
  NoAnswer = 'NO_ANSWER',
}

export enum InterruptionViewStatus {
  Unread = 'UNREAD',
  Seen = 'SEEN',
  Archived = 'ARCHIVED',
}

export type InterruptionContext = {
  creatorEmail?: string;
  creatorName?: string;
  recipientEmail?: string;
  recipientName?: string;

  // Only for redmine now
  source?: string; // redmine
  issueId?: string;
};

export type InterruptionSettings = {
  TTL?: string;
};

export type InterruptionDto = {
  id: string;
  employeeId: string;
  creatorId: string;
  type: InterruptionType;
  lifecycleStatus: InterruptionLifecycleStatus;
  employeeResponseStatus: InterruptionEmployeeResponseStatus;
  viewStatus: InterruptionViewStatus;
  body: string;
  createdAt: string;
  updatedAt?: string | null;
  expiresAt?: string | null;
  sentAt?: string | null;
  context?: InterruptionContext | null;
  settings?: InterruptionSettings | null;
};

export type InterruptionListCardView = {
  chatLink: string;
  creatorId: string;
  creatorName: string;
  id: string;
  message: string;
  recipientName: string;
  type: InterruptionType;
};

export type InterruptionEmergencyCardView = {
  chatLink: string;
  creatorEmail: string;
  direction: InterruptionDirection;
  expiresAtIso: string;
  id: string;
  message: string;
  recipientEmail: string;
  targetUserId: string;
  targetUserName: string;
  teamsCallLink: string;
  type: InterruptionType;
};
